import * as ActionTypes from '../constants/actionTypes';
import { prebookingService } from '../services/prebookingService';
import { toast } from 'react-toastify';


export function getOfferings() {
    
    return (dispatch,getState) => {
        dispatch(request());

        return prebookingService.getOfferings(getState().locationDetail.selectedLocationId, new Date())
        .then((response) => {
            if(response.data.isSuccessful){
                dispatch(success(response.data.data.responseData));
            }
        })
        .catch(error => dispatch(failure(error)));
    };
    function request() { return { type: ActionTypes.GET_PREBOOKING_OFFERING_REQUEST }; }
    function success(data) { return { type: ActionTypes.GET_PREBOOKING_OFFERING_SUCCESS, data }; }
    function failure(error) {
        toast.error("Can not found any offering from this location", {
            autoClose: 10000,
            hideProgressBar: false
        });
        return { type: ActionTypes.GET_PREBOOKING_OFFERING_FAILURE, error }; 
    }
}

export function createBooking(book){
    return (dispatch,getState) => {
        dispatch(request());

        let booking;
        let bookingState = {
            offerId:getState().locationDetail.selectedOffering.id,
            vehicleRegistration:getState().accountDetails.vehiclePlate,
            startDate:getState().locationDetail.startDate,
            endDate:getState().locationDetail.untilDate,    
            grossAmount:getState().pricing.pricingModel.totalAmount,
            vatAmount:getState().pricing.pricingModel.totalVAT,
            ancillaryServices:getState().locationDetail.selectedOptionalServices
        };

        if (!book) {
            booking = bookingState;
        } else {
            book.ancillaryServices =  bookingState.ancillaryServices;
            booking = book;
        }

        return prebookingService.createBooking(booking)
        .then((response) => {
            if(response.data.isSuccessful){
                dispatch(success(response.data.data));
            }
            else{
                dispatch(failure(response.data.validations));
                }
                return response.data;
        })
        .catch(error => dispatch(failure(error)));
    };
    function request() { return { type: ActionTypes.CREATE_BOOKING_REQUEST }; }
    function success(data) { return { type: ActionTypes.CREATE_BOOKING_SUCCESS, data }; }
    function failure(error) {
  
        toast.error(Object.values(error)[0], {
            autoClose: 10000,
            hideProgressBar: false
        });

        return { type: ActionTypes.CREATE_BOOKING_FAILURE, error }; 
    }
}

export function checkSpaceAvailable(startDate, endDate = null, locationId = null,) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            prebookingService.getAvailableSpaces(
                locationId ? locationId : getState().locationDetail.selectedLocationId,
                startDate,
                endDate ? endDate : getState().locationDetail.untilDate
            )
            .then((response) => {
                if (response.data.isSuccessful) {
                    dispatch(success(response.data.data.responseData));
                    resolve(response.data.data.responseData);
                } else {
                    reject("Request was not successful");
                }
            })
            .catch(error => {
                dispatch(failure(error));
                reject(error); 
            });
        });
    };

    function request() { return { type: ActionTypes.CHECK_SPACE_REQUEST }; }
    function success(data) { return { type: ActionTypes.CHECK_SPACE_SUCCESS, data }; }
    function failure(error) {
        toast.error("Can not found any offering from this location", {
            autoClose: 10000,
            hideProgressBar: false
        });
        return { type: ActionTypes.CHECK_SPACE_FAILURE, error }; 
    }
}



export function setSelectedLocation(data){
    return dispatch=>{
        return Promise.resolve(dispatch({ type: ActionTypes.UPDATE_SELECTED_LOCATION_ID,data}));
       }  ;




}

export function resetForm(propertyName, obj) {
    return { type: ActionTypes.RESET_FORM, propertyName, obj};
}

export function updateBookingFromDate(data) {
    return dispatch=>{
        return Promise.resolve(dispatch({ type: ActionTypes.CHANGE_BOOKING_FROM_DATE_TIME, data }));
       }  ;
}
export function updateBookingToDate(data) {
    return dispatch=>{
        return Promise.resolve(dispatch({ type: ActionTypes.CHANGE_BOOKING_TO_DATE_TIME, data }));
       }  ;
}

export function setSelectedOffer(data){
    return dispatch=>{
        return Promise.resolve(dispatch({ type:ActionTypes.SET_SELECT_OFFERING,data }));
       } ; 

}

export function selectedOptionalService(services){

     return dispatch=>{
        return Promise.resolve(dispatch({ type: ActionTypes.SELECT_PARKING_OPTIONAL_SERVICE, services }));
       } ; 
}

export function updateInputValue(target){
    return {type:ActionTypes.UPDATE_USER_DETAIL_INPUT, target};
}

export function calculateOfferPricing(locationId,offeringId){
    return dispatch => {
        dispatch(request());
        return prebookingService.calculateDealPricing(locationId,offeringId)
        .then((response) => {
            dispatch(success(response.data));
        })
        .catch(error => dispatch(failure(error)));
    };
    function request() { return { type: ActionTypes.GET_OFFERING_PRICE_REQUEST }; }
    function success(data) { return { type: ActionTypes.GET_OFFERING_PRICE_SUCCESS, data }; }
    function failure(error) {
        toast.error("Can not found any offering pricing", {
            autoClose: 10000,
            hideProgressBar: false
        });
        return { type: ActionTypes.GET_OFFERING_PRICE_FAILURE, error }; 
    }
}




// WEBPACK FOOTER //
// ./src/actions/homeActions.js